import debounce from "lodash/debounce"

export default class Tabs {
	constructor(tabs) {
		this.tab = tabs
		this.animating = false
		this.active = 0
		this.items = []
		
		if (!this.tab) return
		
		this.getDomElements()

		if (!this.dom.parent || !this.dom.wrapper || !this.dom.keys.length || !this.dom.items.length) return
		
		this.init()
	}


	getDomElements() {
		this.dom = {
			parent : this.tab,
			wrapper: this.tab.querySelector('.js-tabs-wrapper'),
			keys: this.tab.querySelectorAll('.js-tabs-key'),
			items: this.tab.querySelectorAll('.js-tabs-item')
		}
	}


	init() {
		this.setHeight()
		this.setKeys()

		if (this.items.length) {
			this.handleResize()
			this.handleChange()
		}
	}


	animateChange(currentID, newID) {
		// Before Animated
		const activeItem = this.items[currentID]
		const newItem = this.items[newID]
		this.animating = true

		activeItem.key.classList.remove('isActive')
		this.dom.wrapper.style.height =  `${this.dom.wrapper.offsetHeight}px`
		
		setTimeout(() => {
			this.dom.wrapper.style.height = `${newItem.height}px`
			activeItem.item.classList.remove('isActive')

			activeItem.item.style.opacity = 0
			activeItem.item.style.top = `-20px`
			newItem.item.style.top = `20px`
			newItem.item.style.display = 'block'
			newItem.item.style.position = 'absolute'
		}, 100);

		setTimeout(() => {
			newItem.item.style.top = 0
			newItem.item.style.opacity = 1
			newItem.key.classList.add('isActive')
		},410)

		setTimeout(() => {
			this.dom.wrapper.style.height = 'auto'
			activeItem.item.style.display = 'none'
			newItem.item.style.position = 'relative'
			newItem.item.classList.add('isActive')
			this.closeAllAccordions(currentID)
			this.animating = false
		}, 610)
	}


	handleChange() {
		this.dom.keys.forEach(key => {
			key.addEventListener('click', () => {
				const newID = key.dataset.id
				if (this.active == newID || this.animating) return

				this.animateChange(this.active, newID)
				this.active = newID

				console.log(accordions);
			})
		})
	}


	handleResize() {
		window.addEventListener('resize', debounce(() => {
			this.resetHeight()
		}), 1000)
	}


	setHeight() {
		this.dom.items.forEach(item => {
				const itemID = item.dataset.id
				item.style.display = 'block'

				this.items[itemID] = { item: item, height: item.offsetHeight, key: '' }
				
				if (this.active != item.dataset.id) {
					item.style.display = 'none'
				}
		})
	}


	resetHeight() {
		this.items.forEach(item => {
			item.item.style.display = 'block'

			item.height = item.item.offsetHeight

			if (this.active != item.item.dataset.id) {
				item.item.style.display = 'none'
			}
		})
	}


	setKeys() {
		this.dom.keys.forEach(key => {
			const keyID = key.dataset.id
			this.items[keyID].key = key
		})
	}


	closeAllAccordions(currentID) {
		const currentItem = this.items[currentID]
		const accordions = {
			triggers : currentItem.item.querySelectorAll('.js-accordion-trigger'),
			contents : currentItem.item.querySelectorAll('.js-accordion-content'),
		}

		if (!accordions.triggers.length || !accordions.contents.length) return

		accordions.triggers.forEach((trigger) => {
			trigger.classList.remove('active')
		})

		accordions.contents.forEach((content) => {
			content.style.height = '0px'
		})
	}
}
